import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  templateName: Yup.string()
    .matches(
      /^[a-z0-9_]+$/,
      "Template Name can only contain lowercase , numbers and underscores"
    )
    .required("Enter template name."),
  templateLanguage: Yup.object({
    code_id: Yup.string().required("Select template language."),
  }),

  category: Yup.string().required("Category is required"),
  status: Yup.string().required("Select the status"),

  templateHeader: Yup.object().shape({
    type: Yup.mixed().nullable(),

    count_of_variable: Yup.number().nullable(),

    text: Yup.mixed()
      .nullable()
      .when("type", {
        is: (type) => type === "text",
        then: (schema) => schema.required("Text is required"),
        otherwise: (schema) => schema.nullable(),
      }),

    example: Yup.array()
      .nullable()
      .of(
        Yup.object().shape({
          example: Yup.string()
            .nullable()
            .when("count_of_variable", {
              is: (num) => num > 0,
              then: (schema) => schema.required("Fill sample values."),
              otherwise: (schema) => schema.nullable(),
            }),
        })
      ),
  }),

  templateBody: Yup.object().shape({
    text: Yup.string().nullable().required("Body is required"),

    count_of_variable: Yup.number().nullable(),

    example: Yup.array()
      .nullable()
      .of(
        Yup.object().shape({
          example: Yup.string()
            .nullable()
            .when("count_of_variable", {
              is: (num) => num > 0,
              then: (schema) => schema.required("Fill sample values."),
              otherwise: (schema) => schema.nullable(),
            }),
        })
      ),
  }),

  templateButtons: Yup.object().shape({
    type: Yup.mixed().nullable(),
    count_of_variable: Yup.number().nullable(),

    buttons: Yup.array()
      .nullable()
      .of(
        Yup.object().shape({
          button_type: Yup.string()
            .nullable()
            .when("$parentType", {
              is: (type) => type === "call_to_action",
              then: (schema) => schema.required("Select the action type"),
              otherwise: (schema) => schema.nullable(),
            }),

          text: Yup.string().nullable().required("Button text is required"),

          url_type: Yup.string()
            .nullable()
            .when("button_type", {
              is: (type) => type === "url",
              then: (schema) => schema.required("Select the url type"),
              otherwise: (schema) => schema.nullable(),
            }),

          payload: Yup.string()
            .nullable()
            .when("url_type", {
              is: (type) => type === "static",
              then: (schema) =>
                schema
                  .matches(
                    /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\\?[a-zA-Z-_%\\/@?]+)*([^\\/\w\\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/,
                    "Enter correct url."
                  )
                  .required("This is the required field."),
              otherwise: (schema) => schema.nullable(),
            }),
        })
      )
      .when("type", {
        is: (type) => !!type,
        otherwise: (schema) => schema.nullable(),
      }),

    example: Yup.array()
      .nullable()
      .of(
        Yup.object().shape({
          example: Yup.string()
            .nullable()
            .when("count_of_variable", {
              is: (num) => num > 0,
              then: (schema) => schema.required("Fill sample values."),
              otherwise: (schema) => schema.nullable(),
            }),
        })
      ),
  }),
});

export default validationSchema;
